import { start } from "repl";
import { getNormalisedRandomValue } from "../Utility/Statistical";
import { ChatConfigData, ActivityBlockConfigData, ConvertExpressionTypeToNumber, CreativeConfigData, ExpressionType, Media, MessageConfigData, PartyConfigData, PostConfigData, PostElementConfigData, PostPanelConfigData, QuizConfigData, VotesConfigData, GeneratePopularity, ProjectVoting, SubmissionCompetitionConfigData, ActivityBlockType, ExpressionColors } from "./PartyConfigData";
import { AbsoluteTime, ChatDefinition, ChunkDefinitionType, ConvertMedia, PartyDefinition, PostDefinition, VoteSelect } from "./PartyDefinition";
import { convertPartyIdToHex, createPartyComponentId, createPartyIdCopy, PartyComponentId, PartyHexId } from "./PartyId";

import { GetTemplate } from "./PostTemplate";
import { GetPostImage, GetVotableImage, GetUserIcon } from "./ResourceServer";
import { CreativeServerGenConfig } from "../Creative/CreativeServer";

const CHUNK_SIZE = 512 * 1024;

const SizeInJson = (data: any): number => {
    const s = JSON.stringify(data);
    return s.length;
}

export type RegisterItem = {
    inputId: string;
    outputUrl: string;
}

const convertChunkTypeToActivityBlockType = (chunkType: ChunkDefinitionType): ActivityBlockType => {
    if (chunkType === 'chat')
        return 'chat';
    else if (chunkType === 'creative')
        return 'creative';
    else if (chunkType === 'quiz')
        return 'quiz';
    else if (chunkType === 'submission')
        return 'submission';
    else
        return 'post';
}

export const RenderPartyDefinition = (definition: PartyDefinition, s3BaseURL: string): [PartyConfigData, RegisterItem[]] => {
    const register = Array<RegisterItem>();
    var fileIndex = 0;
    const ret = Array<PartyConfigData>();
    var partyId: PartyComponentId = { id: definition.id };
    var hexId = convertPartyIdToHex(partyId).id;

    const party: PartyConfigData = {
        itemId: hexId,
        title: definition.title,
        next: ret.length > 0 ? s3BaseURL + "/" + definition.id + "/settings-" + fileIndex + ".json" : undefined,
        image: definition.image,
        description: definition.description,
        media: [],
        main: [],
        optional: {},
        chats: {},
        triggers: []

    };


    var segmentCounter = 1;

    var segmentTime = 0;
    definition.segments.forEach((segment) => {
        var postCounter = 1;
        var mediaTime = segmentTime;
        segment.media.forEach((item) => { party.media.push(ConvertMedia(item, mediaTime)); mediaTime += item.length; });
        var mainTime = 0;

        segment.main.forEach((chunk) => {
            if (chunk.config !== undefined) {
                var cId = partyId;
                if ((chunk.chunkType === 'voteselect') || (chunk.chunkType === 'post')) {
                    cId = createPartyIdCopy(partyId);
                    cId.main = { post: { id: postCounter } };
                }
                mainTime = Math.max(mainTime, chunk.endTime);

                const chunkOut: ActivityBlockConfigData = {
                    startTime: chunk.startTime + segmentTime,
                    endTime: chunk.endTime + segmentTime,
                    forceOptionalEnd: false,
                    activityType: convertChunkTypeToActivityBlockType(chunk.chunkType),
                    //chatSource: 'integrated',
                    mediaPosition: chunk.mediaPosition,
                    //chatPosition: chunk.chatPosition,
                    config: chunk.chunkType === 'creative' ? chunk.config as CreativeServerGenConfig :
                        (chunk.chunkType === 'quiz' ? chunk.config as QuizConfigData :
                            (chunk.chunkType === 'voteselect' ? RenderVotable(chunk.config as VoteSelect, cId, chunk.startTime + segmentTime, chunk.endTime + segmentTime, party, register, segmentCounter + '.' + postCounter, s3BaseURL) :
                                (chunk.chunkType === 'post' ? RenderPost(chunk.config as PostDefinition, cId, chunk.startTime + segmentTime, chunk.endTime + segmentTime, party, register, segmentCounter + '.' + postCounter, s3BaseURL) :
                                    ((): ChatConfigData => {
                                        const chat = chunk.config as ChatDefinition;
                                        const cpid: PartyComponentId = {
                                            id: partyId.id,
                                            chat: {
                                                id: chat.id ?? 'UNDEFINED' + Math.round(Math.random() * 1000000000)
                                            }
                                        }
                                        return RenderChat(chat, cpid, chunk.startTime + segmentTime, chunk.endTime + segmentTime, 0.25);
                                    })())))
                }
                party.main.push(chunkOut);
                postCounter++;
            }
        });
        const maxTime = Math.max(mainTime, mediaTime - segmentTime);
        if (segment.chats !== undefined) {
            segment.chats.forEach((cd) => {
                const chatId: PartyComponentId = {
                    id: partyId.id,
                    chat: { id: cd.id ?? ('UNDEFINED' + Math.round(Math.random() * 1000000000)) }
                }
                const chatHex = convertPartyIdToHex(chatId);
                const config = RenderChat(cd, chatId, segmentTime, segmentTime + maxTime, 0.25);
                party.chats[chatHex.id] = config;
            });
        }
        Object.keys(segment.optional).forEach((key) => {
            const chunk = segment.optional[key];
            if (chunk.config !== undefined) {
                var cId = partyId;
                if ((chunk.chunkType === 'voteselect') || (chunk.chunkType === 'post')) {
                    cId = createPartyIdCopy(partyId);
                    cId.main = { post: { id: 1000000 + postCounter } };
                }
                mainTime = Math.max(mainTime, chunk.endTime);

                const chunkOut: ActivityBlockConfigData = {
                    startTime: chunk.startTime + segmentTime,
                    endTime: chunk.endTime + segmentTime,
                    forceOptionalEnd: false,
                    activityType: convertChunkTypeToActivityBlockType(chunk.chunkType),
                    //chatSource: 'integrated',
                    mediaPosition: chunk.mediaPosition,
                    //chatPosition: chunk.chatPosition,
                    config: chunk.chunkType === 'creative' ? chunk.config as CreativeServerGenConfig :
                        (chunk.chunkType === 'quiz' ? chunk.config as QuizConfigData :
                            (chunk.chunkType === 'submission' ? RegisterSubmissionCompetition(chunk.config as SubmissionCompetitionConfigData) :
                                (chunk.chunkType === 'voteselect' ? RenderVotable(chunk.config as VoteSelect, cId, chunk.startTime, chunk.endTime, party, register, segmentCounter + '.' + postCounter, s3BaseURL) :
                                    (chunk.chunkType === 'post' ? RenderPost(chunk.config as PostDefinition, cId, chunk.startTime, chunk.endTime, party, register, segmentCounter + '.' + postCounter, s3BaseURL) :
                                        ((): ChatConfigData => {
                                            const chat = chunk.config as ChatDefinition;
                                            const cpid: PartyComponentId = {
                                                id: partyId.id,
                                                chat: {
                                                    id: chat.id ?? 'UNDEFINED' + Math.round(Math.random() * 1000000000)
                                                }
                                            }
                                            return RenderChat(chat, cpid, chunk.startTime + segmentTime, chunk.endTime + segmentTime, 0.25);
                                        })()))))
                }
                party.optional[key] = chunkOut;
            }
        });
        if (segment.triggers !== undefined) {
            segment.triggers.forEach((trigger) => {
                party.triggers.push({ itemId: trigger.id, time: trigger.time + segmentTime, deactivate: trigger.deactivate + segmentTime });
            });
        }
        segmentCounter++;
        segmentTime += maxTime;
    });

    if (definition.chats !== undefined) {
        definition.chats.forEach((cd) => {
            const chatId: PartyComponentId = {
                id: partyId.id,
                chat: { id: cd.id ?? ('UNDEFINED' + Math.round(Math.random() * 1000000000)) }
            }
            const chatHex = convertPartyIdToHex(chatId);
            const config = RenderChat(cd, chatId, 0, segmentTime, 0.25);
            party.chats[chatHex.id] = config;
        });
    }
    var optionalCounter = 1000000;
    Object.keys(definition.optional).forEach((key) => {
        const chunk = definition.optional[key];
        if (chunk.config !== undefined) {
            var cId = partyId;
            if ((chunk.chunkType === 'voteselect') || (chunk.chunkType === 'post')) {
                cId = createPartyIdCopy(partyId);
                cId.main = { post: { id: optionalCounter } };
            }

            const chunkOut: ActivityBlockConfigData = {
                startTime: chunk.startTime,
                endTime: chunk.endTime,
                forceOptionalEnd: false,
                activityType: convertChunkTypeToActivityBlockType(chunk.chunkType),
                //chatSource: 'integrated',
                mediaPosition: chunk.mediaPosition,
                //chatPosition: chunk.chatPosition,
                config: chunk.chunkType === 'creative' ? chunk.config as CreativeServerGenConfig :
                    (chunk.chunkType === 'quiz' ? chunk.config as QuizConfigData :
                        (chunk.chunkType === 'submission' ? RegisterSubmissionCompetition(chunk.config as SubmissionCompetitionConfigData) :
                            (chunk.chunkType === 'voteselect' ? RenderVotable(chunk.config as VoteSelect, cId, chunk.startTime, chunk.endTime, party, register, segmentCounter + '.' + optionalCounter, s3BaseURL) :
                                (chunk.chunkType === 'post' ? RenderPost(chunk.config as PostDefinition, cId, chunk.startTime, chunk.endTime, party, register, segmentCounter + '.' + optionalCounter, s3BaseURL) :
                                    ((): ChatConfigData => {
                                        const chat = chunk.config as ChatDefinition;
                                        const cpid: PartyComponentId = {
                                            id: partyId.id,
                                            chat: {
                                                id: chat.id ?? 'UNDEFINED' + Math.round(Math.random() * 1000000000)
                                            }
                                        }
                                        return RenderChat(chat, cpid, chunk.startTime, chunk.endTime, 0.25);
                                    })()))))
            }
            party.optional[key] = chunkOut;
            optionalCounter++;
        }
    });

    return [party, register];
}

const RegisterSubmissionCompetition = (submission: SubmissionCompetitionConfigData): SubmissionCompetitionConfigData => {

    const register = async () => {
        const response = await fetch("/devapi/createsubmissioncompetition", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ config: submission }),
        });
        const root = await response.json();
    }
    register();
    return submission;

}

export const CreateVoting = (id: PartyComponentId, expressionType: ExpressionType, startTime: number, multiplier? : number, minAge? : number, maxAge? : number, boost? : number, online? : number) => {
    const vid = createPartyIdCopy(id);
    if (vid.chat !== undefined) {
        if (vid.chat.message !== undefined) {
            vid.chat.message.voting = { id: 0 };
        }
    }
    else if (vid.main !== undefined) {
        if (vid.main.post !== undefined) {
            if (vid.main.post.element !== undefined)
                vid.main.post.element.voting = { id: 0 };
            else
                vid.main.post.voting = { id: 0 };
        }
    }
    else if (vid.optional !== undefined) {
        if (vid.optional.post !== undefined) {
            if (vid.optional.post.element !== undefined)
                vid.optional.post.element.voting = { id: 0 };
            else
                vid.optional.post.voting = { id: 0 };
        }
    }

    const vHex = convertPartyIdToHex(vid).id;

    const popularity = GeneratePopularity(true, multiplier ?? 1.0, boost ?? 0.0, online ?? 1.0);
    const age = getNormalisedRandomValue(minAge ?? 6000, maxAge ?? 30000);

    const ret: VotesConfigData = {
        expression: expressionType,
        itemId: vHex,
        created: startTime - age,
        updated: startTime,
        popularity: popularity,
        impressions: 0,
        likes: 0,
        comments: 0
    }

    ProjectVoting(ret, startTime);
    return ret;

}


const RenderPost = (post: PostDefinition, postId: PartyComponentId, startTime: number, endTime: number, party: PartyConfigData, register: RegisterItem[], inputId: string, s3BaseURL: string): PostConfigData => {
    console.log('Rendering Post ' + post.title);
    const postHexId = convertPartyIdToHex(postId);
    const chatId: PartyComponentId = {
        id: postId.id,
        chat: { id: postHexId.post }
    }
    const chatHex = convertPartyIdToHex(chatId);

    const elId = createPartyIdCopy(postId);
    if (elId.main?.post !== undefined) {
        elId.main.post.element = { id: 1 };
    }
    const elHexId = convertPartyIdToHex(elId);



    const ret: PostConfigData = {
        author: post.author,
        title: post.title,
        layout: 'single-element',
        itemId: postHexId.id,
        rotate: 'none',
        messageDisplay: 'post',
        chatId: chatHex.id,
        elements: [],
        voting: CreateVoting(postId, 'undefined', startTime)
    }
    if (ret.voting !== undefined)
        ret.voting.popularity = 1.0;

    const template = GetTemplate(post.postType);
    const hasButton = true; //template !== null ? (template.primary.button === 'action') : false;
    const hasImage = template !== null ? (template.secondary !== undefined ? template.secondary.content === 'image' : false) : false;



    const primary: PostPanelConfigData = {
        text: post.bodyText ?? '',
        buttonText: hasButton ? post.buttonText : undefined,
        buttonClick: hasButton ? post.buttonLink : undefined
    }

    const secondary: PostPanelConfigData | undefined = template !== null ? (template.secondary !== undefined ? (hasImage ? {
        imageSrc: GetPostImage(elHexId, (post.imageExtension ?? 'png'), s3BaseURL),
        imageClick: post.imageLink,
    } : undefined) : undefined) : undefined;

    if (secondary?.imageSrc !== undefined) {
        register.push({ inputId: inputId, outputUrl: secondary.imageSrc });
    }



    ret.elements.push({
        itemId: elHexId.id,
        primary: primary,
        secondary: secondary,
        layout: 'primary-left',
    });

    const chat = RenderChat(post.chat, chatId, startTime, endTime, 0.25);
    party.chats[chatHex.id] = chat;


    return ret;
}

const RenderChat = (chat: ChatDefinition, chatId: PartyComponentId, startTime: number, endTime: number, maxPop: number): ChatConfigData => {

    const chatHex = convertPartyIdToHex(chatId);
    console.log("Rendering chat " + chatHex.id);
    const ret: ChatConfigData = {
        itemId: chatHex.id,
        chatType: 'comment',
        threads: [],
        messages: [],
        startTime: startTime,
        endTime: endTime
    }



    var messageCount = 1;


    chat.comments.forEach((sc) => {
        const mId = createPartyIdCopy(chatId);
        if (mId.chat !== undefined)
            mId.chat.message = { id: messageCount };
        const mHex = convertPartyIdToHex(mId);
        const express = GetUserIcon(sc.expression);
        const color = ExpressionColors[ConvertExpressionTypeToNumber(express[1])];
        const message: MessageConfigData = {
            itemId: mHex.id,
            bodyText: sc.text ?? '',
            voting: CreateVoting(mId, sc.expression, startTime),
            userId: 'SECURITY_MASK',
            nickname: sc.author,
            userIcon: express[0],
            userColor: color,
            replies: [],
            displayStart: sc.displayStart === undefined ? undefined : sc.displayStart + startTime,
            displayEnd: sc.displayEnd === undefined ? undefined : sc.displayEnd + startTime
        }
        ret.messages.push(message);
        messageCount++;
    });
    return ret;


}

const RenderVotable = (voteSelect: VoteSelect, postId: PartyComponentId, startTime: number, endTime: number, party: PartyConfigData, register: RegisterItem[], inputId: string, s3BaseURL: string) => {

    const postHexId = convertPartyIdToHex(postId);
    const chatId: PartyComponentId = {
        id: postId.id,
        chat: { id: postHexId.post }
    }
    const chatHex = convertPartyIdToHex(chatId);
    const ret: PostConfigData = {
        author: 'Fanbox',
        title: 'Track Select',
        layout: 'single-element',
        rotate: 'carousel',
        itemId: postHexId.id,
        elements: [],
        messageDisplay: 'post',
        chatId: chatHex.id,
        elementDisplayTime: 10000,
    }

    const chat: ChatConfigData = {
        itemId: chatHex.id,
        chatType: 'comment',
        threads: [],
        messages: [],
        startTime: startTime,
        endTime: endTime
    }
    party.chats[chatHex.id] = chat;


    var messageCount = 1;
    if (voteSelect.chat !== undefined) {
        voteSelect.chat.comments.forEach((sc) => {
            const mId = createPartyIdCopy(chatId);
            if (mId.chat !== undefined)
                mId.chat.message = { id: messageCount };
            const mHex = convertPartyIdToHex(mId);
            const express = GetUserIcon(sc.expression);
            const color = ExpressionColors[ConvertExpressionTypeToNumber(express[1])];
            const message: MessageConfigData = {
                itemId: mHex.id,
                bodyText: sc.text ?? '',
                voting: CreateVoting(mId, sc.expression, startTime),
                userId: 'SECURITY_MASK',
                nickname: sc.author,
                userIcon: express[0],
                userColor: color,
                replies: [],
                displayStart: sc.displayStart,
                displayEnd: sc.displayEnd
            }
            chat.messages.push(message);
            messageCount++;
        });
    }

    if (voteSelect.votables !== undefined) {
        for (let i = 0; i < voteSelect.votables.length; i++) {
            const votable = voteSelect.votables[i];

            const vid: PartyComponentId = {
                id: postId.id,
                votable: { id: votable.id }
            }
            const vHex = convertPartyIdToHex(vid);
            const primary: PostPanelConfigData = {
                imageSrc: GetVotableImage(vHex, s3BaseURL),
            }
            const eId = createPartyIdCopy(postId);
            if (eId.main?.post !== undefined)
                eId.main.post.element = { id: i + 1 };
            const eHex = convertPartyIdToHex(eId);
            const support = voteSelect.proportionsList !== undefined ? Math.min(voteSelect.proportionsList[i] * 3.2, 1.0) : 1.0;

            const vtid = createPartyIdCopy(eId);
            if (vtid.main?.post?.element !== undefined)
                vtid.main.post.element.voting = { id: 0 };
            const vtHex = convertPartyIdToHex(vtid);


            const eVoting: VotesConfigData = {
                itemId: vtHex.id,
                created: startTime - 5 * 6000,
                updated: startTime,
                likes: 0,
                impressions: 0,
                comments: 0,
                popularity: support
            }

            ProjectVoting(eVoting, startTime);


            const pep: PostElementConfigData = {
                title: votable.name,
                primary: primary,
                itemId: eHex.id,
                layout: 'primary-only',
                voting: eVoting

            };
            if (pep.primary.imageSrc !== undefined) {
                register.push({ inputId: inputId + '-' + votable.id, outputUrl: pep.primary.imageSrc });
            }

            ret.elements.push(pep);


        }
    }
    return ret;
}
